import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'temp-inline-form-actions',
  template: `
    <div class="actions">
      <button
        type="button"
        class="btn btn-primary btn-sm"
        (click)="submit.emit()"
      >
        <span id="submit"><i class="fa-solid fa-save fa-fw"></i></span>
      </button>

      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="cancel.emit()"
      >
        <span id="cancel"><i class="fa-solid fa-times fa-fw"></i></span>
      </button>
    </div>
  `,
  styles: [
    `
      .actions {
        display: flex;
        margin-top: 0.5rem;
        margin-right: 0.5rem;

        button:not(:last-child) {
          margin-right: 2px;
        }
      }
    `,
  ],
  standalone: true,
})
export class InlineFormActionsTemplate {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
